var DefaultLoggerAPI = /** @class */ (function () {
    function DefaultLoggerAPI() {
    }
    DefaultLoggerAPI.prototype.debug = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        console.debug.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        console.info.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        console.warn.apply(console, arguments);
    };
    DefaultLoggerAPI.prototype.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        console.error.apply(console, arguments);
    };
    return DefaultLoggerAPI;
}());
export default new DefaultLoggerAPI();
//# sourceMappingURL=DefaultLoggerAPI.js.map